import React, { useEffect, useState } from "react";
import { API_URL } from "./config";
import { Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import XGolifeDashboardComponent from "./components/XGolifeDashboardComponent";

const OnlineStoreDailyReports = () => {
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [selectedShiftId, setSelectedShiftId] = useState(7); // Default shift ID
  const navigate = useNavigate();

  const companyId = 30; // Hardcoded company ID
  const branchId = 19; // Hardcoded branch ID
  const operatorId = 1; // Example operator ID
  const shiftStatus = "open"; // Example shift status

  useEffect(() => {
    const fetchShifts = async () => {
      const url = `${API_URL}/shift/getShiftByCompanyBranchOperatorStatus/${companyId}/${branchId}/${operatorId}/${shiftStatus}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch shifts");
        const data = await response.json();
        setShifts(data);
      } catch (error) {
        console.error("Error fetching shifts:", error);
        setError(error.message);
      }
    };

    fetchShifts();
  }, [companyId, branchId, operatorId, shiftStatus]);

  useEffect(() => {
    const fetchSalesData = async () => {
      const url = `${API_URL}/salepostrans/get_sale_pos_trans_sold_by_shift/${branchId}/${companyId}/${selectedShiftId}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setSalesData(data);
      } catch (error) {
        console.error("Error fetching sales data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSalesData();
  }, [branchId, companyId, selectedShiftId]);

  const handleShiftChange = (event) => {
    setSelectedShiftId(event.target.value);
  };

  const handleBack = () => {
    navigate("/pos"); // Navigate back to POS
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Alert variant="danger">Error: {error}</Alert>
      </div>
    );
  }

  return (
    <XGolifeDashboardComponent>
      <div style={{ backgroundColor: "#ffffff", minHeight: "100vh", padding: "20px" }}>
        <h1 className="text-2xl font-semibold text-black mb-6">Daily Sales Report</h1>

        <div className="mb-4">
          <label htmlFor="shiftSelect" className="block mb-2 text-sm font-medium text-gray-700">
            Select Shift:
          </label>
          <select
            id="shiftSelect"
            value={selectedShiftId}
            onChange={handleShiftChange}
            className="block w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
          >
            {shifts.map((shift) => (
              <option key={shift.shift_id} value={shift.shift_id}>
                Shift ID: {shift.shift_id} - Opened: {shift.date_time_open}
              </option>
            ))}
          </select>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                {["ID", "Date & Time", "Cashier", "Product", "Quantity", "Price", "Total Value Released"].map((header) => (
                  <th key={header} className="border border-gray-300 px-4 py-2 text-left text-black font-semibold">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {salesData.length > 0 ? (
                salesData.map((sale, index) => (
                  <tr key={sale.payid} className={`hover:bg-gray-100 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
                    <td className="border border-gray-300 px-4 py-2 text-black">#{sale.payid}</td>
                    <td className="border border-gray-300 px-4 py-2 text-black">
                      {new Date(sale.daterec).toLocaleDateString()} {sale.timerec}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-black">{sale.username}</td>
                    <td className="border border-gray-300 px-4 py-2 text-black">{sale.product_name}</td>
                    <td className="border border-gray-300 px-4 py-2 text-black">{sale.quantity}</td>
                    <td className="border border-gray-300 px-4 py-2 text-black">${sale.selling_price.toFixed(2)} {sale.currency}</td>
                    <td className="border border-gray-300 px-4 py-2 text-black">${(sale.selling_price * sale.quantity).toFixed(2)} {sale.currency}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="border border-gray-300 px-4 py-2 text-center text-black">
                    No sales data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </XGolifeDashboardComponent>
  );
};

export default OnlineStoreDailyReports;